import { clearTrackingEvents, setTrackingEvents } from '../../services/trackingService';
import './store.component.scss';

export default function StoreView() {
    return {
        oncreate: () => setTrackingEvents('a.target-link', 'store'),
        onremove: () => clearTrackingEvents('a.target-link'),
        view: () => (<>
            <div class="headline">
                <h2>Visit Our Bandcamp Page</h2>
            </div>
            <div class="content store-content">
                <div class="content__row content__row--store box-border-rough">
                    <div class="store-item">
                        <a class="target-link" data-type="merch" data-target="bandcamp-anthropocene" href="https://voidhunter.bandcamp.com/album/anthropocene" target="_blank">
                            <img src="/assets/merch-anthropocene.1800x1800.jpg" />
                            Anthropocene EP
                        </a>
                    </div>
                    <div class="store-item">
                        <a class="target-link" data-type="merch" data-target="bandcamp-tshirt" href="https://voidhunter.bandcamp.com/merch/anthropocene-t-shirt" target="_blank">
                            <img src="/assets/merch-tshirt.1800x1800.jpg" />
                            Anthropocene T-Shirt
                        </a>
                    </div>
                    <div class="store-item">
                        <a class="target-link" data-type="merch" data-target="bandcamp-stickers" href="https://voidhunter.bandcamp.com/merch/stickers-set-of-3" target="_blank">
                            <img src="/assets/merch-stickers.1800x1800.jpg" />
                            Logo Stickers
                        </a>
                    </div>
                </div>
            </div>
        </>),
    };
}
